<template>
    <!-- eslint-disable max-len -->
    <svg
        v-if="type === 'full'"
        class="a-logo"
        :class="className"
        title="Acronis"
        viewBox="0 0 158 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0 31.5362H4.82319L7.14203 25.7855H24.2551L26.5275 31.5362H31.3507L18.1797 0H13.171L0 31.5362ZM11.687 14.5159L12.4754 12.4754C13.8203 9.13623 14.9797 6.35362 15.6754 4.26667C16.4174 6.35362 17.5768 9.13623 18.9217 12.4754L19.7565 14.5159H11.687ZM44.2435 32C50.2261 32 54.9565 28.7072 56.4406 22.771H51.6638C50.6435 26.0174 48 27.8261 44.429 27.8261C39.513 27.8261 36.4522 24.3478 36.4522 19.2928C36.4522 14.4696 39.3275 10.7594 44.3826 10.7594C48 10.7594 50.5507 12.429 51.6174 16.1855H56.3942C55.3275 10.1101 50.6435 6.58551 44.4754 6.58551C37.287 6.58551 31.7217 11.7333 31.7217 19.2928C31.7217 26.6203 36.5449 32 44.2435 32ZM60.0116 31.5362H64.6493V18.8754C64.6493 14.5159 65.9942 11.7333 70.8638 11.7333H71.5594V6.58551H71.142C68.2667 6.58551 65.9942 7.97681 64.4638 10.1565L64.2783 7.04928H60.0116V31.5362ZM85.1478 32C92.5681 32 97.9942 26.6203 97.9942 19.2928C97.9942 12.058 92.6609 6.58551 85.1478 6.58551C77.9131 6.58551 72.3015 11.7797 72.3015 19.2928C72.3015 26.6203 77.7275 32 85.1478 32ZM101.426 31.5362H106.064V17.4377C106.064 13.4493 108.614 10.8058 112.742 10.8058C116.545 10.8058 118.122 12.9855 118.122 16.9739V31.5362H122.759V16.0928C122.759 10.0174 119.513 6.58551 113.716 6.58551C110.377 6.58551 107.78 7.6058 105.878 9.6L105.554 7.04928H101.426V31.5362ZM147.988 32C150.957 32 153.275 31.4435 155.038 30.0058C156.707 28.6609 157.588 26.6203 157.588 24.3015C157.588 22.1217 156.615 19.9884 154.574 18.8754C153.043 18.0406 151.374 17.7159 149.565 17.4377C147.664 17.1594 145.438 16.9275 144.232 16.4638C143.026 16 142.377 15.3043 142.377 13.9594C142.377 11.8725 144.186 10.342 147.246 10.342C150.122 10.342 152.348 11.7333 152.626 14.5623H157.032C156.754 9.22898 152.951 6.58551 147.246 6.58551C142.006 6.58551 137.925 9.32174 137.925 14.5159C137.925 16.742 138.806 18.7362 141.032 19.8029C142.47 20.4986 144.139 20.8696 146.551 21.2406C148.87 21.6116 150.029 21.7971 151.142 22.2145C152.301 22.6319 153.043 23.2812 153.043 24.858C153.043 27.1304 150.864 28.2435 147.988 28.2435C144.51 28.2435 142.145 26.9449 141.681 23.9768H137.183C137.646 29.7739 142.006 32 147.988 32ZM127.815 31.5362H132.406V7.04928H127.815V31.5362ZM85.1942 27.8261C80.4638 27.8261 77.0783 24.3478 77.0783 19.2464C77.0783 14.4696 80.0928 10.7594 85.1478 10.7594C90.1102 10.7594 93.2638 14.4232 93.2638 19.2464C93.2638 24.1623 89.971 27.8261 85.1942 27.8261ZM8.71884 21.8435L10.2029 18.2261H21.2406L22.6783 21.8435H8.71884Z"
        />
    </svg>
    <svg
        v-else
        class="a-logo"
        :class="className"
        title="Acronis"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M3 46H9.47463L12.5874 38.1588H35.5599L38.6105 46H45.0851L27.4044 3H20.6807L3 46ZM18.6885 22.7926L19.7469 20.0103C21.5523 15.4574 23.1087 11.6632 24.0426 8.81765C25.0387 11.6632 26.5951 15.4574 28.4005 20.0103L29.5211 22.7926H18.6885ZM14.7041 32.7838L16.6963 27.8515H31.5133L33.4432 32.7838H14.7041Z"
        />
    </svg>
</template>

<script>
import { COLORS, TYPES } from '@core/components/logo/constants.js';

export default {
    name: 'ALogo',
    props: {
        /**
         * Icon type
         */
        type: {
            type: String,
            required: false,
            default: undefined,
            validator: (value) => value === undefined || TYPES.includes(value),
        },

        /**
         * Icon fill
         * Default color: var(--av-nav-primary)
         */
        fill: {
            type: String,
            required: false,
            default: undefined,
            validator: (value) => value === undefined || COLORS.includes(value),
        },
    },

    computed: {
        /**
         * Returns classes for component
         *
         * @returns {{[className]: condition}
         */
        className() {
            const { type, fill } = this;
            return {
                [`a-logo_type_${type}`]: type,
                [`a-logo_fill_${fill}`]: fill,
            };
        },
    },
};
</script>

<style lang="postcss" scoped>
.a-logo {
    fill: var(--av-nav-primary);
    width: 40px;
    height: 40px;
    display: inline-block;
    vertical-align: bottom;

    @media (--viewport-desktop) {
        width: 48px;
        height: 48px;
    }

    &_type {
        &_full {
            height: 27px;
            width: 133px;

            @media (--viewport-desktop) {
                height: 32px;
                width: 158px;
            }
        }
    }

    &_fill {
        &_white {
            fill: var(--av-inversed-primary);
        }
    }
}
</style>
